import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MobileListRenderItemInfo } from 'drf-react-by-schema';

import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import CheckIcon from '@mui/icons-material/Check';
import PauseIcon from '@mui/icons-material/Pause';

import { Layout } from 'src/styles';
import { AzeiteOrOleo } from 'src/@types';
import { AzeiteOrOleoProductionStatus } from 'src/constants';
import { getAzeiteOrOleoName } from 'src/utils/utils';

import AsmubipButton from './AsmubipButton';
import StatusChip from './StatusChip';

export default function AzeiteOrOleoProductionCard({ item, id }: MobileListRenderItemInfo) {
  const navigate = useNavigate();
  const status = item.status.value.value as AzeiteOrOleoProductionStatus;
  const azeiteOrOleo = item.azeite_or_oleo.value.value as AzeiteOrOleo;
  const path = `${azeiteOrOleo}_production`;
  const name = getAzeiteOrOleoName({ azeiteOrOleo });
  return (
    <Card sx={Layout.mobileCard} variant="outlined">
      <CardContent sx={Layout.productionCardContent}>
        <Box sx={Layout.productionCardIconWrapper}>
          {status !== AzeiteOrOleoProductionStatus.COMPLETE ? (
            <PauseIcon sx={Layout.productionCardIcon} />
          ) : (
            <CheckIcon sx={Layout.productionCardIcon} />
          )}
        </Box>
        <Box>
          {status === AzeiteOrOleoProductionStatus.COMPLETE ? (
            <Box>
              {item.volume_produzido.valueStr} litros de {name}
            </Box>
          ) : (
            <Box>{item.peso_amendoas.valueStr} Kg de amêndoa</Box>
          )}
          {item.perfil && (
            <Box sx={{ color: (theme) => theme.palette.primary.main }}>{item.perfil.valueStr}</Box>
          )}
          {item.grupo && <Box>{item.grupo.valueStr}</Box>}
          {item.comunidade && (
            <Box>
              <Typography variant="caption">{item.comunidade.valueStr}</Typography>
            </Box>
          )}
          {status === AzeiteOrOleoProductionStatus.COMPLETE ? (
            <Box>{item.data_armazenamento.valueStr}</Box>
          ) : (
            <Box>
              <Typography variant="caption">Iniciada em {item.data_quebra.valueStr}</Typography>
            </Box>
          )}
          <Box>
            <Typography variant="caption">Lote {item.lote.valueStr}</Typography>
          </Box>
          <StatusChip type={azeiteOrOleo} status={status} />
        </Box>
      </CardContent>
      <CardActions>
        {status !== AzeiteOrOleoProductionStatus.COMPLETE ? (
          <AsmubipButton
            variant="contained-dark"
            size="large"
            sx={Layout.productionCardActionSingle}
            onClick={() => {
              navigate(`/${path}/edit/${id}`);
            }}>
            Finalizar a produção
          </AsmubipButton>
        ) : (
          <Box sx={Layout.productionCardActionWrapper}>
            <AsmubipButton
              variant="outlined"
              size="large"
              sx={Layout.productionCardActionSingle}
              onClick={() => {
                navigate(`/${path}/view/${id}`);
              }}>
              Ver detalhes
            </AsmubipButton>
            {/* <AsmubipButton
              variant="contained-dark"
              size="medium"
              startIcon={<WhatsAppIcon sx={{ color: 'inherit' }} />}>
              Compartilhar
            </AsmubipButton> */}
          </Box>
        )}
      </CardActions>
    </Card>
  );
}
